// Get references to the video element and the button
var videos = document.querySelectorAll('.product-single__video video');
videos.forEach(video => {
	// Add a click event listener to the button
	video.addEventListener('click', function() {
	  if (video.paused) {
		// If the video is paused, play it
		video.play();
	  } else {
		// If the video is playing, pause it
		video.pause();
	  }
	});
})




var check_kiwi_load = setInterval(function () {
	// Check every second that kiwi has loaded
	if (
		$("body").find(".size-guide-container .ks-modal-content-hidden")
			.length
	) {
		var content = $(".size.o-accordion__item .o-accordion__content").html();
		var product_image = $("body")
			.find(".o-slider__item:first-child .o-single-product__slider-image")
			.get(0).outerHTML;

		if (!content) {
			content = ''
		}

		$("body")
			.find(".ks-modal-content-hidden .ks-chart-individual")
			.prepend(
				'<div class="ks-html-content size-info-pull flex"><div style="width: 120px">' +
					product_image +
					'</div><div style="margin-left: 20px">' +
					content +
					"</div></div>"
			);


				// duplicate the button generated by kiwi app
		var sizingContent = $("body").find(".ks-chart-container.sizing-chart-container.ks-container-with-modal").html()
		$("body").find(".size.o-accordion__item .o-accordion__content").append(sizingContent)

		$("body").on('click', ".size.o-accordion__item .ks-chart-modal-link", function(){
			$(function() {
				$("body").find('.size-guide-container .ks-chart-modal-link').trigger('click');
			});
		})


		clearInterval(check_kiwi_load);
	} else {
		clearInterval(check_kiwi_load);
	}
}, 1000);

var targets = gsap.utils.toArray(".koibird-star");
targets.forEach((element) => {
	gsap.fromTo(
		element,
		{
			y:
				-element.closest(".tiles").querySelector(".tile").offsetHeight *
					0.8 +
				"px",
		},
		{
			scrollTrigger: {
				trigger: element.closest(".tiles"),
				start: "top 95%",
				end: "bottom bottom",
				scrub: true,
				// markers: true,
			},
			y: 0,
			ease: "power1.out",
		}
	);
});

$(
	".tiles__container.tiles-count-4, .tiles__container.tiles-count-3.contains-tile-width-2"
).each(function () {
	$(this).slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		mobileFirst: true,
		prevArrow: $(this).next().find(".c-product-carousel___arrows--left"),
		nextArrow: $(this).next().find(".c-product-carousel___arrows--right"),
		responsive: [
			{
				breakpoint: 550,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 992,
				settings: "unslick",
			},
		],
	});
});

// $(".tiles__container.tiles-count-3.contains-tile-width-2").slick({
// 	infinite: true,
// 	slidesToShow: 1,
// 	slidesToScroll: 1,
// 	mobileFirst: true,
// 	responsive: [
// 		{
// 			breakpoint: 550,
// 			settings: {
// 				slidesToShow: 2,
// 			},
// 		},
// 		{
// 			breakpoint: 992,
// 			settings: "unslick",
// 		},
// 	],
// });

var split = new SplitText('.k-submenu__item a[boutique], .k-submenu__item a[href*="/pages/sign-up"]', {
	charsClass: "split-char",
});

// $('.k-submenu__item a.k-submenu__link--level-two[href*="collections/sale"]').css("color", "#D82C26");
// $('.k-submenu__item a[href*="pages/vintage"]').css("color", "#8F74DD");
$('.k-submenu__item a[boutique], .k-submenu__item a[href*="/pages/sign-up"]').on("mouseenter", function () {
	gsap.timeline({
		// onStart: () => {
		// 	$(this).css("pointer-events", "none");
		// },
		// onComplete: () => {
		// 	$(this).css("pointer-events", "");
		// },
	})
		.to($(this).find(".split-char"), {
			y: -10,
			stagger: 0.1,
			duration: 0.3,
		})
		.to(
			$(this).find(".split-char"),
			{
				y: 0,
				stagger: 0.1,
				duration: 0.3,
				// onComplete: () => {
				// 	$(this).css("pointer-events", "");
				// },
			},
			0.2
		);
});

/* ====== Product Images Carousel on PDP  ====== */

$(document).ready(function () {
	// setTimeout(function () {
	$(".slider--simple").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		asNavFor: ".slider--thumbnails",
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					infinite: true,
					dots: true,
				},
			},
		],
	});

	// $('.slider--thumbnails').slick({
	//     slidesToShow: 4,
	//     slidesToScroll: 1,
	//     asNavFor: '.slider--simple',
	//     focusOnSelect: true,
	//     vertical: true,
	//     prevArrow: $('.thumbs_arrow--left'),
	//     nextArrow: $('.thumbs_arrow--right'),
	//     arrows: true
	// });

	// Product Detail Page Mobile Carousel slide Indicator

	var $status = $(".o-single-product__sliders__paging-info");
	var $productDetailMobileCarousel = $(".o-single-product__images-container");

	$productDetailMobileCarousel.on(
		"init reInit afterChange",
		function (event, slick, currentSlide, nextSlide) {
			//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
			var i = (currentSlide ? currentSlide : 0) + 1;

			var first = i;
			if (first < 10) {	
			  first = "0" + i
			}
			var second = slick.slideCount;
			if (second < 10) {	
			  second = "0" + second
			}
			$status.text(first + "/" + second);
		}
	);

	$(".o-single-product__images-container").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
		slide: ".o-slider__item",
		appendDots: ".o-single-product__vendor",
		infinite: true,
		mobileFirst: true,
		centerMode: true,
		centerPadding: "20px",
		responsive: [
			{
				breakpoint: 1024,
				settings: "unslick",
			},
		],
	});

	$(window).resize(function () {
		if ($(window).width() < 1024) {
			$(".o-single-product__images-container").slick("refresh");
		}
	});
	// }, 5000);


if ($('.template-customers-account').length) {
	setInterval(function(){
		if (!$('.lion-rule-item--birthday .lion-action-button').hasClass('lion-action-button--disabled') && !$('.lion-rule-item--birthday .lion-action-button').hasClass('lion-action-button--completed')) {
			$('.bday-item').show()
		} else {
			$('.bday-item').hide()
		}
	}, 2000)


	// $('.account-info').css('height', $(window).height() - $('header').height())
	// $('.account-info-inner').css('top', $('.account-info').height() / 2)
	// gsap.set('.account-info-inner', { y: '-50%' })

	ScrollTrigger.matchMedia({
	
		// desktop
		"(min-width: 900px)": function() {

			$('.account-info').css('height', $(window).height() - $('header').height())
			$('.account-info-inner').css('top', $('.account-info').height() / 2)
			gsap.set('.account-info-inner', { y: '-50%' })

			ScrollTrigger.create({
				trigger: ".account-info-inner",
				start: "top 120",
				// markers: true,  
				pin: true,
				end: "bottom "+ ($('.account-info').height() - $('.account-info-inner').height() + 75),
				endTrigger: ".account-wrapper"
			});


		}, 
		
		// mobile
		"(max-width: 899px)": function() {

			

		}, 
		
		// all 
		"all": function() {
			// ScrollTriggers created here aren't associated with a particular media query,
			// so they persist.
		}

	});


	$(window).on('resize', function(){
		$('.account-info').css('height', $(window).height() - $('header').height())
		$('.account-info-inner').css('top', $('.account-info').height() / 2)
		ScrollTrigger.refresh()
		if ($(window).width() < 900) {
			gsap.set('.account-info-inner', { y: '0%' })
		} else {
			gsap.set('.account-info-inner', { y: '-50%' })
		}
	})

	$('.account-menu button').each(function(){
		var page = $(this).attr('data-page')
		$(this).on('click', function(){
			$('.accpage').hide()
			$('.accpage[data-accpage="'+page+'"]').show()
			// $('.account-info').css('height', $('.accpage[data-accpage="'+page+'"]').height())
			ScrollTrigger.refresh()
		})
	})

}



// setTimeout(function(){
	loyalty_page()
// }, 1000)
// $(window).on('resize', loyalty_page)

function loyalty_page() {


	// $('.loyalty-tiers__slider').on('init', function(slick){
	
	// 	console.log('test');
		
				
	// 			$('.loyalty-tiers__slider .slick-arrow').css('top', $('.loyalty-tiers__slide.slick-current .loyalty-desk-img img').height() + $('.loyalty-tiers__slide.slick-current .loyalty-tiers__text').height() / 2 - 20)
	// 			// gsap.to('.loyalty-tiers__slider .slick-arrow', {opacity: 1})
								
		
	// });
		

	$('.loyalty-tiers__slider').slick({
		infinite: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots: true,
		mobileFirst: true,
		prevArrow: '<button type="button" class="slick-prev"><svg width="22px" height="40px" viewBox="0 0 22 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="07_D-shopping-cart" transform="translate(-798.000000, -810.000000)" fill="#FFFFFF"><path d="M799.633221,809.99995 C800.051481,809.99995 800.465385,810.156798 800.783438,810.47485 L818.359099,828.268356 C819.308899,829.231226 819.308899,830.773563 818.363456,831.736433 L800.866218,849.516868 C800.230114,850.15733 799.193176,850.161687 798.552714,849.525582 C797.912252,848.889477 797.907896,847.856896 798.544,847.216435 C807.196768,838.507028 811.845561,833.832094 814.420478,831.318173 C815.156791,830.603644 815.182932,829.444714 814.455333,828.717114 C810.799909,825.04862 803.654623,817.933832 798.483004,812.792711 C797.842542,812.156607 797.838185,811.124026 798.47429,810.483564 C798.792343,810.161155 799.21496,809.99995 799.633221,809.99995" id="Fill-1"></path></g></g></svg></button>',
		nextArrow: '<button type="button" class="slick-next"><svg width="22px" height="40px" viewBox="0 0 22 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="07_D-shopping-cart" transform="translate(-798.000000, -810.000000)" fill="#FFFFFF"><path d="M799.633221,809.99995 C800.051481,809.99995 800.465385,810.156798 800.783438,810.47485 L818.359099,828.268356 C819.308899,829.231226 819.308899,830.773563 818.363456,831.736433 L800.866218,849.516868 C800.230114,850.15733 799.193176,850.161687 798.552714,849.525582 C797.912252,848.889477 797.907896,847.856896 798.544,847.216435 C807.196768,838.507028 811.845561,833.832094 814.420478,831.318173 C815.156791,830.603644 815.182932,829.444714 814.455333,828.717114 C810.799909,825.04862 803.654623,817.933832 798.483004,812.792711 C797.842542,812.156607 797.838185,811.124026 798.47429,810.483564 C798.792343,810.161155 799.21496,809.99995 799.633221,809.99995" id="Fill-1"></path></g></g></svg></button>',
		responsive: [
			// {
			// 	breakpoint: 550,
			// 	settings: {
			// 		slidesToShow: 2,
			// 	},
			// },
			// {
			// 	breakpoint: 992,
			// 	settings: "unslick",
			// },
		],
	});



	if ($(window).width() > 992) {
		
		$('.loyalty-tiers__slide').css('height', $(window).height() - $('header').height())
	}
	$(window).on('resize', function(){
		if ($(window).width() > 992) {
		
			$('.loyalty-tiers__slide').css('height', $(window).height() - $('header').height())
		}
	})





// 	if ($('body').hasClass('template-page-loyalty') && $(window).width() > 900) {


// 		loyalty_calc()
// 		$(window).on('resize', loyalty_calc)
// 		function loyalty_calc() {

// 			$('.loyalty-tiers__slide').css('height', $(window).height() - $('header').height())
// 			// $(window).on('resize', function(){
// 			// 	$('.loyalty-tiers__slide').css('height', $(window).height() - $('header').height())
// 			// })

// 			console.log($('.loyalty-tiers__slide.active .loyalty-desk-img img').height());
// 			setTimeout(function(){
// 				console.log($('.loyalty-tiers__slide.active .loyalty-desk-img img').height());
// 			}, 5000)

// 			$('.loyalty-tiers__arrows').css('width', $('.loyalty-tiers').width() - 40)
			
// 			setTimeout(function(){
// 				$('.loyalty-tiers__arrows').css('top', $('.loyalty-tiers__slide.active .loyalty-desk-img img').height() + $('.loyalty-tiers__slide.active .loyalty-tiers__text').height() / 2 - 20)
// 				gsap.to('.loyalty-tiers__arrows', {opacity: 1})
// 			}, 1000)

// 			// console.log('refresh?');
// 			// ScrollTrigger.refresh()

// 		}

// 		let sections = gsap.utils.toArray(".loyalty-tiers__slide");

// 		let scrollTween = gsap.to(sections, {
// 			xPercent: -100 * (sections.length - 1),
// 			ease: "none",
// 			scrollTrigger: {
// 				trigger: ".loyalty-tiers__slider",
// 				pin: true,
// 				id: 'slider',
// 				scrub: true,
// 				start: "top " + $('header').height(),
// 				end: "+=3000",
// 				invalidateOnRefresh: true,
// 				refreshPriority: 1,
// 				onRefresh: () => {
// 					console.log('refresdh');
// 				},
// 				onUpdate: self => {
// 					// console.log("progress:", self.progress)
// 					$(".loyalty-tiers__slider").attr('data-progress',  self.progress)
// 					// console.log('fromtop ' + $('#shopify-section-loyalty-tiers').offset().top)
// 				}
// 			}
// 		});


// 		ScrollTrigger.create({
// 			trigger: "#loyalty-tiers__slide-1",
// 			containerAnimation: scrollTween,
// 			start: "top 50%",
// 			end: "bottom 50%",
// 			// markers: true,
// 			// toggleClass: "active",
// 			onEnter: () => {
// 				$("#loyalty-tiers__slide-1").addClass('active')
// 				$("#loyalty-tiers__slide-2").addClass('next-slide')
// 			},
// 			onEnterBack: () => {
// 				$("#loyalty-tiers__slide-1").addClass('active')
// 				$("#loyalty-tiers__slide-2").addClass('next-slide')
// 			},
// 			onLeave: () => {
// 				$("#loyalty-tiers__slide-1").removeClass('active')
// 				$("#loyalty-tiers__slide-2").removeClass('next-slide')
// 			},
// 			onLeaveBack: () => {
// 				$("#loyalty-tiers__slide-1").removeClass('active')
// 				$("#loyalty-tiers__slide-2").removeClass('next-slide')
// 			}
// 		});

// 		ScrollTrigger.create({
// 			trigger: "#loyalty-tiers__slide-2",
// 			containerAnimation: scrollTween,
// 			start: "top 50%",
// 			end: "bottom 50%",
// 			// markers: true,
// 			// toggleClass: "active",
// 			onEnter: () => {
// 				$("#loyalty-tiers__slide-2").addClass('active')
// 				$("#loyalty-tiers__slide-1").addClass('prev-slide')
// 				$("#loyalty-tiers__slide-3").addClass('next-slide')
// 			},
// 			onEnterBack: () => {
// 				$("#loyalty-tiers__slide-2").addClass('active')
// 				$("#loyalty-tiers__slide-1").addClass('prev-slide')
// 				$("#loyalty-tiers__slide-3").addClass('next-slide')
// 			},
// 			onLeave: () => {
// 				$("#loyalty-tiers__slide-2").removeClass('active')
// 				$("#loyalty-tiers__slide-1").removeClass('prev-slide')
// 				$("#loyalty-tiers__slide-3").removeClass('next-slide')
// 			},
// 			onLeaveBack: () => {
// 				$("#loyalty-tiers__slide-2").removeClass('active')
// 				$("#loyalty-tiers__slide-1").removeClass('prev-slide')
// 				$("#loyalty-tiers__slide-3").removeClass('next-slide')
// 			}
// 		});

// 		ScrollTrigger.create({
// 			trigger: "#loyalty-tiers__slide-3",
// 			containerAnimation: scrollTween,
// 			start: "top 50%",
// 			end: "bottom 50%",
// 			// markers: true,
// 			// toggleClass: "active",
// 			onEnter: () => {
// 				$("#loyalty-tiers__slide-3").addClass('active')
// 				$("#loyalty-tiers__slide-2").addClass('prev-slide')
// 				$("#loyalty-tiers__slide-4").addClass('next-slide')
// 			},
// 			onEnterBack: () => {
// 				$("#loyalty-tiers__slide-3").addClass('active')
// 				$("#loyalty-tiers__slide-2").addClass('prev-slide')
// 				$("#loyalty-tiers__slide-4").addClass('next-slide')
// 			},
// 			onLeave: () => {
// 				$("#loyalty-tiers__slide-3").removeClass('active')
// 				$("#loyalty-tiers__slide-2").removeClass('prev-slide')
// 				$("#loyalty-tiers__slide-4").removeClass('next-slide')
// 			},
// 			onLeaveBack: () => {
// 				$("#loyalty-tiers__slide-3").removeClass('active')
// 				$("#loyalty-tiers__slide-2").removeClass('prev-slide')
// 				$("#loyalty-tiers__slide-4").removeClass('next-slide')
// 			}
// 		});

// 		ScrollTrigger.create({
// 			trigger: "#loyalty-tiers__slide-4",
// 			containerAnimation: scrollTween,
// 			start: "top 50%",
// 			end: "bottom 50%",
// 			// markers: true,
// 			// toggleClass: "active",
// 			onEnter: () => {
// 				$("#loyalty-tiers__slide-4").addClass('active')
// 				$("#loyalty-tiers__slide-3").addClass('prev-slide')
// 			},
// 			onEnterBack: () => {
// 				$("#loyalty-tiers__slide-4").addClass('active')
// 				$("#loyalty-tiers__slide-3").addClass('prev-slide')
// 			},
// 			onLeave: () => {
// 				$("#loyalty-tiers__slide-4").removeClass('active')
// 				$("#loyalty-tiers__slide-3").removeClass('prev-slide')
// 			},
// 			onLeaveBack: () => {
// 				$("#loyalty-tiers__slide-4").removeClass('active')
// 				$("#loyalty-tiers__slide-3").removeClass('prev-slide')
// 			}
// 		});




// 		$('.loyalty-tiers__arrows button.next-tier').on('click', function(){
// 			if ($(document).find('.loyalty-tiers__slide.next-slide').length) {
// 				$('html, body').animate({
// 					scrollTop: $(document).find('.loyalty-tiers__slide.next-slide').attr('data-position-end')
// 				})
// 			}
// 		})

// 		$(document).find('.loyalty-tiers__slide').each(function(){
// 			$(this).attr('data-position-end', ($(this).index() - 1) * 1000 + $('#shopify-section-loyalty-tiers').offset().top)
// 		})

// 		$('.loyalty-tiers__arrows button.prev-tier').on('click', function(){
// 			if ($(document).find('.loyalty-tiers__slide.prev-slide').length) {
// 				$('html, body').animate({
// 					scrollTop: $(document).find('.loyalty-tiers__slide.prev-slide').attr('data-position-start')
// 				})
// 			}
// 		})

// 		$(document).find('.loyalty-tiers__slide').each(function(){
// 			$(this).attr('data-position-start', ($(this).index() - 1) * 1000 + $('#shopify-section-loyalty-tiers').offset().top)
// 		})

// 	}

}


});


$(document).find('.o-cart__wishlist button').on('click', function(){
	$(this).parent().prev().trigger('click')
})



$('.swiper-card-vars').each(function(){

	var thisSwiper = $(this);

	var swiper = new Swiper(this, {
		// init: false,
		width: 280,
		autoplay: false,
		loop: false,
		slidesPerView: 'auto',
		// slidesPerView: 2,
		spaceBetween: 8,
		slidesPerGroup: 1,
		// centeredSlides: true,
		centeredSlidesBounds: true,
		navigation: {
			nextEl: $(this).find('.swiper-button-next')[0],
			prevEl: $(this).find('.swiper-button-prev')[0]
		}
	});

	var slides = thisSwiper.find('.swiper-wrapper .swiper-slide');
	var arrowPrev = thisSwiper.find('.swiper-button-prev');
	var arrowNext = thisSwiper.find('.swiper-button-next');


	
	if (slides.length < 6) {
		arrowPrev.hide()
		arrowNext.hide()
	}

})

$('.swiper-card-vars-mob').each(function(){

	if ($(this).find('.swiper-wrapper').children().length > 3) { 

		var thisSwiper = $(this);

		var swiper = new Swiper(this, {
			// init: false,
			// width: 150,
			autoplay: false,
			loop: false,
			slidesPerView: 3,
			// slidesPerView: 2,
			spaceBetween: 8,
			// slidesPerGroup: 1,
			centeredSlides: true,
			centeredSlidesBounds: true,
			navigation: {
				nextEl: $(this).find('.swiper-button-next')[0],
				prevEl: $(this).find('.swiper-button-prev')[0]
			}
		});

		var slides = thisSwiper.find('.swiper-wrapper .swiper-slide');
		var arrowPrev = thisSwiper.find('.swiper-button-prev');
		var arrowNext = thisSwiper.find('.swiper-button-next');

	} else {
		$(this).find('.swiper-wrapper').css('justify-content', 'center')
		$(this).find('.swiper-slide').css('width', 'max-content').css('margin', '0 3px')
	}

})






$('.swiper').each(function(){

	var thisSwiper = $(this)

	var swiper = new Swiper(this, {
		// init: false,
		loop: true,
		slidesPerView: 2,
		spaceBetween: 20,
		navigation: {
		nextEl: $(this).find('.swiper-button-next')[0],
		prevEl: $(this).find('.swiper-button-prev')[0]
		}
	});

	if ($(window).width() > 850) {
		// swiper.init(this)
		thisSwiper.find('.swiper-button-prev').addClass('swiper-button-lock');
		thisSwiper.find('.swiper-button-next').addClass('swiper-button-lock');
	}

	setTimeout(function(){
		var height = thisSwiper.find('.bundle-product-image').height();
		gsap.set(thisSwiper.find('.swiper-button'), {'top': height / 2, yPercent: -50, marginTop: '0px'});
	}, 500)
	
	$(window).on('resize', function(){

		var height = thisSwiper.find('.bundle-product-image').height();
		// thisSwiper.find('.swiper-button').css('top', height / 2).css('transform', '');
		gsap.to(thisSwiper.find('.swiper-button'), {'top': height / 2, yPercent: -50, marginTop: '0px'});

		if ($(window).width() > 850) {
			swiper.disable();
		} else {
			swiper.enable();
			if (swiper.slides.length < 2) {
				thisSwiper.find('.swiper-button-prev').addClass('swiper-button-lock');
				thisSwiper.find('.swiper-button-next').addClass('swiper-button-lock');
			}
		}
	})

})



var mm = gsap.matchMedia();

mm.add("(min-width: 900px)", () => {

	ScrollTrigger.create({
		trigger: ".bundle-section",
		start: "top " + $('header').height(),
		end: 'bottom ' + ($('header').height() + $('.bundle-inner').height()),
		// markers: true,
		pin: '.bundle-inner'
	});


	$('#bundle-selector').imagesLoaded(function(){
		ScrollTrigger.refresh();
	});

});


















// abc charm product
if ($('body').hasClass('template-product')) {
if (window.SwymProductInfo.product.id === 7004023652415) {
	$('.o-single-product__variant-size-container input').on('click', function(){
		$(document).find('.custom-order-variant').remove();
		if ($(this).attr('data-cs') < 1) {
			$('.o-single-product__size-selector').after('<p class="custom-order-variant">This is custom order so can take up to 10 days to deliver</p>');
		}
	})
}
}




function playPauseVideo() {
    var videos = document.querySelectorAll(".c-product-tile__image video");
    videos.forEach((video) => {
        // We can only control playback without insteraction if video is mute
        video.muted = true;
        // Play is a promise so we need to check we have it
        var playPromise = video.play();
        if (playPromise !== undefined) {
            playPromise.then((_) => {
                var observer = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => {
                            if (
                                entry.intersectionRatio !== 1 &&
                                !video.paused
                            ) {
                                video.pause();
                            } else if (video.paused) {
                                video.play();
                            }
                        });
                    },
                    { threshold: 1 }
                );
                observer.observe(video);
            });
        }
    });
}

// And you would kick this off where appropriate with:
// playPauseVideo();


// subheader-menu section

var menus = document.querySelectorAll('.subheader-menu');

menus.forEach((element, index) => {
  gsap.to(element, {
    scrollTrigger: {
      trigger: element,
      start: 'top '+ $('header').height(),
	  end: "max",
      pin: true,
	  pinSpacing: false,
    //   markers: true,
    },
  });
});



// mob product cards

$('.product-card-plus').on('click', function(){
	let minus = $(this).find('.lucide-minus')
	let plus = $(this).find('.lucide-plus')
	let mobMenu = $(this).closest('.product-card').find('.product-card-mobile-menu')
	let labels = $(this).closest('.product-card').find('.product-tile-labels')
	let info = $(this).closest('.product-card').find('.product-card-info')

	

	if (!$(this).hasClass('active')) {

		gsap.to(minus, {opacity: 1, duration: .5})
		gsap.to(plus, {opacity: 0, duration: .5})
		gsap.to(mobMenu, {opacity: 1, duration: .5})
		gsap.to(labels, {opacity: 0, duration: .5})
		gsap.to(info, {autoAlpha: 0, duration: .5})

		$(this).addClass('active')

	} else {

		gsap.to(minus, {opacity: 0, duration: .5})
		gsap.to(plus, {opacity: 1, duration: .5})
		gsap.to(mobMenu, {opacity: 0, duration: .5})
		gsap.to(labels, {opacity: 1, duration: .5})
		gsap.to(info, {autoAlpha: 1, duration: .5})

		$(this).removeClass('active')

		gsap.to('.product-card-mobile-menu-add-var', { autoAlpha: 0, pointerEvents: 'none' })
		gsap.to('.swym-add-to-wishlist-view-product', { autoAlpha: 1, pointerEvents: 'auto' })

	}

	
})


$('.product-card-mobile-menu-add').on('click', function(){
	let vars = $(this).closest('.product-card').find('.product-card-mobile-menu-add-var')
	gsap.to(vars, { autoAlpha: 1, pointerEvents: 'auto' })
	gsap.to($(this).closest('.product-card').find('.swym-add-to-wishlist-view-product'), { autoAlpha: 0, pointerEvents: 'none' })
})


// ScrollTrigger.create({
// 	trigger: ".l-collection-page__filter-facets",
// 	start: "top top+=" + $("header").height() + 'px',
// 	end: 'max',
// 	pin: ".l-collection-page__filter-facets",
// 	pinType: "fixed",
// 	markers: true,
// 	onToggle: () => {
// 		$(".l-collection-page__filter-facets--md").toggleClass('l-collection-page__filter-facets--scrolled')
// 	}
//   });

var swiper = new Swiper('.swiper-footer', {
    slidesPerView: 2,
    // spaceBetween: 20,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    breakpoints: {
      992: {
        slidesPerView: 5,
        autoplay: false,
      }
    }
  });